'use client'

import FormPasswordRecover from '@/entities/FormPasswordRecover'
import { Helmet } from 'react-helmet'
import '@/r-pages/LoginPage/ui/LoginPage.scss'
import { useInView } from 'react-intersection-observer'
import FormPasswordChange from '@/entities/FormPasswordChange'

export const PasswordChange = ({data}) => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })

    return (
        <div
            ref={ref}
            className={`LoginPage ${
                inView && 'animate__animated animate__slideInLeft'
            }`}
        >
            <Helmet>
                <title>Восстановление пароля</title>
            </Helmet>
            <div>
                <h1>Восстановление пароля</h1>
                <div className={'form-container'}>
                    <FormPasswordChange backData={data} />
                </div>
            </div>
        </div>
    )
}       